import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

const InpputCheck = ({ id, label, error, value, switchCheck, info, disabled, ...props }) => {
	return (
		<div className={`form-check ${switchCheck ? 'form-switch' : ''}`}>
			<input
				className='form-check-input'
				role={switchCheck ? 'switch' : 'checkbox'}
				type='checkbox'
				value={value}
				id={id}
				disabled={disabled}
				{...props}
			/>
			{label && (
				<label className='form-check-label d-flex' htmlFor={id}>
					{label}
					{info && (
						<Tooltip title={info}>
							<InfoCircleFilled className='mx-1' />
						</Tooltip>
					)}
				</label>
			)}
			{error && error.message && <div className='invalid-feedback d-block'>{error.message}</div>}
		</div>
	);
};

InpputCheck.propTypes = {
	id: PropTypes.any,
	label: PropTypes.string,
	error: PropTypes.object,
	value: PropTypes.bool,
	switchCheck: PropTypes.bool
};

export default InpputCheck;
